import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";
import up from "../../../assets/images/thirdbg.png"

const VideoBK = styled.div`
display:flex;
align-items:center;
gap:30PX;
@media screen and (max-width:599px){
  display:grid;
}
`; const GridHEading = styled(Grid)`
display:flex;
align-items: start;

place-content: ${(props) => (props.pc ? props.pc : "center")};
`;
const GridImage = styled(Grid)`
text-align: left;
`;
const JOiningLinks = styled.img`
  width: 100%;
  height:auto;
  max-width: ${(props) => (props.mw ? props.mw : "400PX")};
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const FeatureWrapper = styled.div`
 background: 
    linear-gradient(#000000 0 0) padding-box, /*this is your grey background*/
    linear-gradient(319deg, #000,#000,#000, #1765FF) border-box;
  border: 1px solid transparent;
backdrop-filter: blur(13px) !important;
  padding: 20px;
`

const TgImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 170px;
`;
const BuyNow = styled.a`
text-decoration: none;
/* display:flex;
align-items:center; */
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textPrimary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 15px;
font-size:20px;
padding: 20px 30px 0;
margin-right: 15px;
font-family:"G-B";
border:1px solid #fff;
@media screen and (max-width:1009px){
  /* padding: 8px 37px; */
}
@media screen and (max-width:499px){
  font-size:15px;
  /* padding: 8px 20px; */
}
@media screen and (max-width:399px){
  /* padding: 8px 12px; */
}


`
const Div = styled.div`
  /* min-height: 100vh; */
  background-image: url(${up});
  background-size: cover;
  background-position: center center;
`;

const SectionSubHeadingSpan = styled.span`
color: ${(props) => (props.color ? props.color : "#88F846")};
   text-transform: uppercase;
font-family: Poppins-Bold;
  font-size: ${(props) => (props.fs ? props.fs : "55px")};
  padding: ${(props) => (props.p ? props.p : "0 10PX")};
  margin: ${(props) => (props.m ? props.m : "20PX 0")};
  text-align: ${(props) => (props.align ? props.align : "")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "")};
  
  @media (max-width: 1299px) {
  }
  @media (max-width: 599px) {
    /* width: ${(props) => (props.mw ? props.mw : "18%")}; */
    padding: ${(props) => (props.p599 ? props.p599 : "")};
    line-height: ${(props) => (props.lh ? props.lh : "")};
    font-size: ${(props) => (props.fs599 ? props.fs599 : "30px")};
  }
`;
const S2_Aboutus = () => {
  return (
    <Div>
      <SectionWrapper p="8rem 0" id="Twerknomic" align="center">
        <Container maxWidth="xl">
          <Grid container justifyContent="center">

            <GridImage item xs={12} md={6} lg={7.5}>
              <SectionSubHeading
              fs="55px"
                color="#fff"
                p599="30PX 0"
                p="0"
                align="center"
                m="0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >
                <SectionSubHeadingSpan>$BITCONNECT</SectionSubHeadingSpan> is a memecoin with
                <SectionSubHeadingSpan color="#F8BA3F">Same</SectionSubHeadingSpan> total supply <SectionSubHeadingSpan color="#F8BA3F">
                  as bitcoin </SectionSubHeadingSpan>
                built on <SectionSubHeadingSpan color="#006FFF"> Ethereum</SectionSubHeadingSpan>
                <SectionSubHeadingSpan color="#FE2525">95%</SectionSubHeadingSpan>  of all tokens
                are distributed at <SectionSubHeadingSpan color="#FFFF00">launch.</SectionSubHeadingSpan>
              </SectionSubHeading>

            </GridImage>

          </Grid>
        </Container>
      </SectionWrapper>
    </Div>
  );
};

export default S2_Aboutus;
